import { Component } from '@angular/core';
import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { AppConfig } from "../model/config";

@Component({
  selector: 'app-checkin',
  templateUrl: './checkin.component.html',
  styleUrls: ['./checkin.component.css']
})
export class CheckinComponent {

  employmentNumber: string = "";

  constructor(private readonly toaster: ToastrService, private readonly configuration: AppConfig, private readonly httpClient: HttpClient) {

  }

  keypadClick(value: number) {
    this.employmentNumber += value;
    console.log(value);
  }

  clear(): void {
    this.employmentNumber = "";
  }

  login(): void {
    if (this.employmentNumber === "") {
      this.toaster.error("Ange anställningsnummer", null, {timeOut: 5000});
      return;
    }

    this.checkinOrOut(this.employmentNumber)
      .then(reply => {
        if (reply === true) {
          this.toaster.info('Du har nu checkat in', null, { timeOut: 5000 });
        }
        else {
          this.toaster.info('Du har nu checkat ut', null, { timeOut: 5000 });
        }
        return true;
      }, (error) => {
        this.toaster.error("Ett fel uppstod vid in/utcheckning!");
        return false;
      });

    this.employmentNumber = "";
  }

  checkinOrOut(employmentNumber: string): Promise<any> {

    return this.post(this.configuration.backendUrl + "/api/checkinuser/toggle", JSON.stringify(employmentNumber),
      (result) => { },
      (exception) => { }).toPromise<any>();
  }

  private post(url: string, item: any, onSuccess, onError): Observable<any> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',

      })
    };

    return this.httpClient.post<any>(url, item, httpOptions)
      .pipe(
        tap(
          success => {
            onSuccess(success);
          },
          exception => {
            onError(exception);
          }
        ))

  }
}
